import "../css/main";
import { explainerMobileMenu } from "../header";
import { carousels } from "../templates/components/carousel";
import { columns } from "../templates/components/columns";
import { heroVideos } from "../templates/components/hero";
import { initProjects } from "../templates/components/projects_overview";
import { scrollToContactForm } from "./utils";

document.addEventListener("DOMContentLoaded", () =>
  [
    columns,
    initProjects,
    explainerMobileMenu,
    carousels,
    heroVideos,
    scrollToContactForm,
  ].forEach((x) => x())
);
